export default __webpack_public_path__ + "static/media/akash.9d05ae93.png";